import {
  GET_LIST_DANHSACHKIEMKHO,
  GET_LIST_DANHSACHKIEMKHO_SUCCESS,
  GET_LIST_DANHSACHKIEMKHO_FAILURE,
} from "../../actions/DanhSachKiemKho/actionTypes";

const initialState = {
  List: [],
  TotalQuantity: 0,
};
const getListDanhSachKiemKho = (state, action) => ({
  ...state,
  getListDanhSachKiemKhoLoading: true,
});

const getListDanhSachKiemKhoSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TotalQuantity: action.payload.TotalQuantity,
    getListDanhSachKiemKhoLoading: false,
  };
};

const getListDanhSachKiemKhoFailed = (state, action) => ({
  ...state,
  getListDanhSachKiemKhoLoading: false,
  List: [],
});
export const listDanhSachKiemKhoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHKIEMKHO:
      return getListDanhSachKiemKho(state, action);
    case GET_LIST_DANHSACHKIEMKHO_SUCCESS:
      // alert("tuty");
      return getListDanhSachKiemKhoSuccess(state, action);
    case GET_LIST_DANHSACHKIEMKHO_FAILURE:
      //alert('false')
      return getListDanhSachKiemKhoFailed(state, action);
    default:
      return state;
  }
};

export default listDanhSachKiemKhoReducer;
